import CustomModal from '../../Global/CustomModal';
import { useNavigate } from 'react-router-dom';

interface UpgradeModalProps {
  open: boolean;
  close: () => void;
  context: 'qbank' | 'default';
}

const UPGRADE_CONTEXT_MAP = {
  qbank: {
    title: 'Upgrade for Full QBank Access',
    text: 'Your current plan gives you 3 daily QBank for this exam.',
  },
  default: {
    title: 'Upgrade to Unlock this Content',
    text: 'This content is only available to paid users.',
  },
};

const UpgradeModal: React.FC<UpgradeModalProps> = ({
  open,
  close,
  context = 'default',
}) => {
  const navigate = useNavigate();
  return (
    <CustomModal open={open} onClose={close} name={'upgrade'} glass={true}>
      <div className="modal_header">
        <h2>{UPGRADE_CONTEXT_MAP[context].title}</h2>
      </div>
      <div className="modal_content">
        <p className="m-0">{UPGRADE_CONTEXT_MAP[context].text}</p>
      </div>
      <div className="modal_actions">
        <button
          className="button button--light-gradient"
          onClick={() => navigate('/pricing')}
        >
          Upgrade Now
        </button>
      </div>
    </CustomModal>
  );
};

export default UpgradeModal;
